import { render } from "./ReturnPortalReturnEntireOrderConfirmation.vue?vue&type=template&id=22fad5a2"
import script from "./ReturnPortalReturnEntireOrderConfirmation.vue?vue&type=script&lang=js"
export * from "./ReturnPortalReturnEntireOrderConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__